import axios from "axios";

let installed = false;

export function installHttpAuth() {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token && !config.headers?.Authorization) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error?.response?.status === 401) {
        clearSessionAndRedirect();
      }
      return Promise.reject(error);
    }
  );
}

const LOGIN_PATH = "/authentication/log-in";

// On an expired/invalid token the server returns 401. Clear the stale session
// and send the user to the login page (Dag 7) so they don't sit on a broken
// authenticated view. Guarded so we never loop while already on the login page.
export function clearSessionAndRedirect() {
  ["token", "user", "role", "loggedIn", "vendor_id", "inputEnabled", "app_keys"].forEach((k) =>
    localStorage.removeItem(k)
  );
  if (typeof window !== "undefined" && window.location.pathname !== LOGIN_PATH) {
    window.location.assign(LOGIN_PATH);
  }
}
